import React from 'react';
import type { FooterLinkGroup } from './FooterTypes';
import { slugify } from './FooterUtils';
import FooterLinkItem from './FooterLinkItem';

type FooterColumnProps = {
  group: FooterLinkGroup;
};

const FooterColumn = ({ group }: FooterColumnProps): JSX.Element => (
  <nav
    className={`footer-col footer-col--${group.key}`}
    aria-label={group.title}
  >
    <h3 className="footer-heading">{group.title}</h3>

    <ul className="footer-list">
      {group.links.map((link) => (
        <FooterLinkItem
          key={`${group.key}-${slugify(link.label)}`}
          link={link}
        />
      ))}
    </ul>
  </nav>
);

export default FooterColumn;
